import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Table, TableHead, TableBody, TableCell, TableContainer, TableRow, IconButton } from '@mui/material'
import { Delete } from '../../../../../assets/img/icons'
import keywordManagement from '../../../../../services/keywordManagement.service'
import { LoaderDots, Confirmation } from '../../../../../components'
import { useGlobalStore } from '../../../../../store'
import { GridWrapper, TableWrapper } from './style'
// import { consoleLog } from '../../../../../util'

const Grid = ({ refreshData }) => {
  const [gridData, setGridData] = useState([])
  const [loader, setLoader] = useState(true)
  const [deleteObject, setDeleteObject] = useState(null)
  const { company } = useGlobalStore()

  const onload = async () => {
    setLoader(true)
    const payload = { organizationId: company?.OrganizationId }
    const response = await keywordManagement.getOrganizationAggregationSubKeywordDetailsApi(payload)

    setGridData(response)
    setTimeout(() => {
      setLoader(false)
    }, 500)
  }

  const deleteFunc = async (obj) => {
    const payload_level1 = {
      organizationId: company?.OrganizationId,
      delete: true,
      parentKeywordValues: { string: obj.KeywordValue },
      subKeywordLevel1Values: { string: obj.SubKeywordLevel1Value },
      subKeywordLevel2Values: { }
    }
    const payload_level2 = {
      ...payload_level1,
      subKeywordLevel2Values: { string: obj.SubKeywordLevel2Value }
    }
    await keywordManagement.setOrganizationAggregationSubKeywordsApi(payload_level2)
    await keywordManagement.setOrganizationAggregationSubKeywordsApi(payload_level1)
    // consoleLog('deleteApi, !deleteApi, !!deleteApi -- ', deleteApi, !deleteApi, !!deleteApi)
    // if(!!deleteApi){
    //   consoleLog('deleteApi -- ', deleteApi)
    // }

    setDeleteObject(null)
    onload()
  }

  useEffect(() => {
    onload()
  }, [refreshData])

  useEffect(() => {
    onload()
  }, [company?.OrganizationId])

  return (
    <GridWrapper>
      <TableWrapper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          {gridData?.length > 0 && <Table aria-labelledby='tableTitle' size='medium'>
            <TableHead>
              <TableRow>
                <TableCell>Keyword</TableCell>
                <TableCell>Sub Keyword Level 1</TableCell>
                <TableCell>Sub Keyword Level 2</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {gridData?.map((row, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell>{row.KeywordValue}</TableCell>
                    <TableCell>{row.SubKeywordLevel1Value}</TableCell>
                    <TableCell>{row.SubKeywordLevel2Value}</TableCell>
                    <TableCell className='actionWrapper'>
                      {/* <IconButton className={`${row.IsDeleted ? 'IsDeleted' : ''}`} onClick={() => deleteFunc(row)}><Delete active={row.IsDeleted} /></IconButton> */}
                      {(row.SubKeywordLevel1Value || row.SubKeywordLevel2Value) && <IconButton className={`${row.IsDeleted ? 'IsDeleted' : ''}`} onClick={() => setDeleteObject(row)}><Delete active={row.IsDeleted} /></IconButton>}
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>}

          {deleteObject && <Confirmation
            open={true}
            title='Are you sure you want to delete this row?'
            onClose={() => setDeleteObject(null)}
            onCancel={() => setDeleteObject(null)}
            onSubmit={() => deleteFunc(deleteObject)}
          />}

          {loader && <LoaderDots /> }
          {!loader && gridData?.length === 0 && (
            <Table>
              <TableRow>
                <TableCell>
                  No Data Found
                </TableCell>
              </TableRow>
            </Table>
          )}
        </TableContainer>
      </TableWrapper>
    </GridWrapper>
  )
}

Grid.propTypes = {
  refreshData: PropTypes.number
}

export default Grid
